import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import axios from "axios";
import {
  Box,
  useTheme,
  useMediaQuery,
  TextField,
  Button,
  IconButton,
} from "@mui/material";
import Header from "../components/Header";
import StatBox from "../components/StatBox";
import { tokens } from "../theme";
import {
  DataGrid,
  GridActionsCellItem,
  GridCsvExportMenuItem,
  GridPrintExportMenuItem,
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExportContainer,
  GridToolbarFilterButton,
  GridToolbarQuickFilter,
} from "@mui/x-data-grid";
import { AddCircle, Delete, Message } from "@mui/icons-material";
import Grid from "@mui/material/Grid";
import config from "./global/config";

function Dashboard() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const url = config.apiUrl + "dashboard.php";

  // const [data, setDataDeposit] = useState([]);

  const [dataDeposit, setDataDeposit] = useState([]);

  const [dataProfile, setDataProfile] = useState([]);
  const [dataUnite, setDataUnite] = useState([]);
  const [dataStatut, setDataStatut] = useState([]);
  const [dataSelected, setDataSelected] = useState({
    deposit: "",
    profile: "",
    unites: "",
  });

  const clearSelected = () => {
    setDataSelected({
      deposit: "",
      profile: "",
    });
  };

  const [textValueD, setTextValueD] = useState("");
  const [textValueP, setTextValueP] = useState("");
  const [textValueU, setTextValueU] = useState("");
  const [textValueS, setTextValueS] = useState("");

  const HandleChange = (e) => {
    const { name, value } = e.target;
    setDataSelected((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    console.log(dataSelected);
  };

  const requestGetProfile = async () => {
    try {
      const response = await axios.get(url, {
        params: { profile: "" },
      });
      setDataProfile(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  const requestPostProfile = async (profile) => {
    var f = new FormData();
    f.append("profile", profile);
    f.append("METHOD", "POST");
    try {
      const response = await axios.post(url, f, {
        params: { profile: "" },
      });
      // setDataDeposit(response.data);
      requestGetProfile();
    } catch (error) {
      console.error(error);
    }
  };

  const requestDeleteProfile = async (profile) => {
    var f = new FormData();
    f.append("METHOD", "DELETE");
    await axios
      .post(url, f, { params: { profile: profile } })
      .then((response) => {
        // setDataProfile(response.data);
        requestGetProfile();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    requestGetProfile();
  }, []);

  return (
    <Box m="25px">
      <Header
        title="Configuration"
        subtitle="Configurer tous les options possibles de l'application."
      />
      <Box m="40px 0 0 0" height="75vh" sx={{}}>
        <Grid container spacing={2}>
          {/* <Grid item xs={3}> */}
          {/* <Box
              p="10px 0px 10px 0px"
              // gridColumn="span 3"
              // backgroundColor={colors.primary[400]}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <TextField
                fullWidth
                variant="filled"
                select
                label={
                  dataDeposit.length > 0
                    ? "Choisissez un Profile"
                    : "pas de Profiles disponibles"
                }
                onChange={HandleChange}
                name="deposit"
                SelectProps={{
                  native: true,
                }}
                sx={{ gridColumn: "span 4" }}
              >
                {dataDeposit.length > 0 ? (
                  <option value="" selected></option>
                ) : null}{" "}
                {dataDeposit.map((item) => (
                  <option value={item.deposit} key={item.deposit}>
                    {item.deposit}
                  </option>
                ))}
              </TextField>
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  requestDeleteDeposit(dataSelected.deposit);
                }}
              >
                <Delete fontSize="inherit" />
              </IconButton>
            </Box>
          </Grid> */}
          <Grid item xs={3}>
            <Box
              p="10px 0px 10px 0px"
              // gridColumn="span 3"
              // backgroundColor={colors.primary[400]}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Profile"
                // onBlur={handleBlur}
                value={textValueP}
                onChange={(e) => {
                  HandleChange(e);
                  setTextValueP(e.target.value);
                }}
                name="profile"
                // error={!!touched.firstName && !!errors.firstName}
                // helperText={touched.firstName && errors.firstName}
                sx={{ gridColumn: "span 8" }}
              />
              <IconButton
                color="secondary"
                size="large"
                onClick={
                  dataSelected.profile != ""
                    ? () => {
                        requestPostProfile(dataSelected.profile);
                        // clearSelected();
                        setTextValueP("");
                      }
                    : () => {}
                }
              >
                <AddCircle fontSize="inherit" />
              </IconButton>
            </Box>
            <Box
              p="10px 0px 10px 0px"
              // gridColumn="span 3"
              // backgroundColor={colors.primary[400]}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <TextField
                fullWidth
                variant="filled"
                select
                label={
                  dataProfile.length > 0
                    ? "Choisissez un Profile"
                    : "pas de Profiles disponibles"
                }
                onChange={HandleChange}
                name="profile"
                SelectProps={{
                  native: true,
                }}
                sx={{ gridColumn: "span 4" }}
              >
                {dataProfile.length > 0 ? (
                  <option value="" selected></option>
                ) : null}
                {dataProfile.map((item) => (
                  <option value={item.profile} key={item.profile}>
                    {item.profile}
                  </option>
                ))}
              </TextField>
              <IconButton
                color="secondary"
                size="large"
                onClick={() => {
                  requestDeleteProfile(dataSelected.profile);
                }}
              >
                <Delete fontSize="inherit" />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default Dashboard;
